import React from "react";
import { observer } from "mobx-react-lite";
import { Box, Button, IconButton, Typography } from "@mui/material";

import ChevronLeftIcon from "../../icons/ChevronLeftIcon";
import EyeIcon from "../../icons/EyeIcon";

import Column from "../../ui/core/Column";
import Row from "../../ui/core/Row";
import WelcomeSection from "../../ui/home/WelcomeSection";

interface PolicyWelcomeContentProps {
  onBack: () => void;
  isPanelOpen: boolean;
  policyTitle?: string;
  onOpenPanel: () => void;
}

const PolicyWelcomeContent: React.FC<PolicyWelcomeContentProps> = observer(
  ({ onBack, isPanelOpen, policyTitle, onOpenPanel }) => {
    return (
      <>
        <Box
          sx={{
            width: "100%",
            px: 2,
            py: 1,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            ...(isPanelOpen
              ? {}
              : { borderBottom: "1px solid", borderColor: "divider" }),
          }}
        >
          <Row sx={{ alignItems: "center", gap: 1.5, flex: 1, minWidth: 0 }}>
            {!isPanelOpen && policyTitle ? null : (
              <Button
                onClick={onBack}
                aria-label="Back to all policies"
                startIcon={<ChevronLeftIcon className="w-4 h-4" />}
                sx={{
                  flexShrink: 0,
                  borderRadius: "999px",
                  px: 2,
                  py: 0.5,
                  bgcolor: "background.paper",
                  border: "1px solid",
                  borderColor: "divider",
                  color: "primary.main",
                  fontWeight: 600,
                  textTransform: "none",
                  boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
                  "&:hover": {
                    bgcolor: "action.hover",
                    borderColor: "divider",
                  },
                }}
              >
                All policies
              </Button>
            )}

            {!isPanelOpen && policyTitle ? (
              <>
                <IconButton aria-label="Back to all policies" onClick={onBack}>
                  <ChevronLeftIcon className="w-4 h-4" />
                </IconButton>
                <Typography fontWeight={600} noWrap sx={{ minWidth: 0 }}>
                  {policyTitle}
                </Typography>
              </>
            ) : null}
          </Row>

          {!isPanelOpen ? (
            <Button
              variant="contained"
              color="primary"
              size="small"
              endIcon={<EyeIcon width={16} height={16} />}
              onClick={onOpenPanel}
              sx={{ flexShrink: 0, borderRadius: "999px", px: 2 }}
            >
              Open Policies
            </Button>
          ) : null}
        </Box>

        <Box sx={{ width: "100%", flex: 1, overflow: "auto", minHeight: 0 }}>
          <Column sx={{ justifyContent: "center", alignItems: "center" }}>
            <WelcomeSection
              subtitle={
                policyTitle
                  ? "Ask questions about this policy"
                  : "Ask questions about payer policies"
              }
            />
          </Column>
        </Box>
      </>
    );
  },
);

export default PolicyWelcomeContent;
